import styled from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
  background: #000000;

  .main-panel {
    /* max-width is set dynamically via inline style based on panel_width config */
    /* Default removed - now uses config value */
  }

  .wrapper {
    align-items: center;
    height: fit-content;
  }
`;
